import { useUserProfile } from "Settings/User/Api/Query/useUserProfileQuery";
import { UserProfileHeader } from "Settings/User/Components/UserProfileHeader";
import { getUserProfileTabs } from "Settings/User/Pages/hooks/useUserProfileTabs";
import { PageContainer } from "Shared/Components/Container";
import { Loading } from "Shared/Components/Loading/Loading";
import { Tabs } from "Shared/Components/Tabs";
import { useNavigateTabs } from "Shared/Components/Tabs/Hooks/useNavigateTabs";
import type { FC } from "react";

type Props = {
	currentTab: string;
};

export const UserProfile: FC<Props> = ({ currentTab }) => {
	const tabs = getUserProfileTabs();
	const { data: user, isLoading } = useUserProfile();

	return (
		<PageContainer
			title="User profile"
			description="Detailed information about your user profile"
		>
			{isLoading && <Loading />}
			{user && <UserProfileHeader user={user} />}
			<Tabs value={currentTab} tabs={tabs} hookFunction={useNavigateTabs} />
		</PageContainer>
	);
};
